/**
 * Card container styling matching the dashboard cards — rounded-lg, white
 * surface, a subtle shadow (dashboardShadows.card) and no border — so the
 * Rapports page reads as one system with the embedded dashboard charts
 * (SFRESTO-87). Callers add their own padding.
 */
export const reportCard =
  "rounded-lg bg-white shadow-[0_1px_3px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)]";

/** Subtle inner surface for elements nested inside a report card. */
export const reportInnerCard = "rounded-lg bg-gray-50";
